module.exports = __webpack_public_path__ + "media/auth-right-video.c0134263.mp4";